
import { useToast as useShadcnToast, toast as shadcnToast } from "@/hooks/use-toast";

// Re-export the toast hooks and functions from the actual implementation
export const useToast = useShadcnToast;
export const toast = shadcnToast;
